import Dimensions from './Dimensions'
import LockerSizeJson from './interfaces/LockerSizeJson'

export default class LockerSize {
  id: number
  label: string
  dimensions: Dimensions
  types: Array<string>

  constructor(
    id: number,
    label: string,
    dimensions: Dimensions,
    types: Array<string>,
  ) {
    this.id = id
    this.label = label
    this.dimensions = dimensions
    this.types = types
  }

  static fromJson(data: LockerSizeJson) {
    return new this(
      data.id,
      data.label,
      Dimensions.fromJson(data.dimensions),
      data.types,
    )
  }
}
